var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeProspectDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeProspectDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icLikeProspectDesktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05273061,5.08986683 C5.75494558,4.3636171 6.67822768,4 7.60276059,4 C8.5272935,4 9.4552215,4.36361857 10.1574514,5.08986683 L10.9996983,5.96359973 L11.8419602,5.09446542 C13.2464051,3.641938 15.5422364,3.64197038 16.9466664,5.09446542 C18.3511112,6.54696194 18.3511112,8.87976477 16.9466664,10.3322628 C15.0354021,12.3089372 13.1250013,14.287819 11.213752,16.2644493 C11.1574954,16.3232224 11.0792399,16.3565215 10.9973754,16.3565215 C10.9155109,16.3565215 10.8372554,16.3232224 10.7809988,16.2644493 L5.05273061,10.3276568 C3.64989401,8.87403456 3.64828582,6.5423398 5.05273061,5.08986683 Z",
    id: "path-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeProspectDesktop);
export default __webpack_public_path__ + "static/media/icLikeProspectDesktop.d904df6dced2b74efdefd61e2853a9f5.svg";
export { ForwardRef as ReactComponent };